import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

export interface DealerStatusOption {
  key: string;
  value: string;
}

class Dealer {
  static ENDPOINT = 'api/v2/dealers';

  static async getDealerStatuses(): Promise<APIResponseType<DealerStatusOption[]>> {
    try {
      const response = await apiService.get<APIResponseType<DealerStatusOption[]>>(
        `${this.ENDPOINT}/statuses`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getAllDealersForDataGrid(params: any): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}/datagrid`, params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async addDealer(payload: any): Promise<APIResponseType> {
    try {
      const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteDealer(dealerId: string): Promise<APIResponseType> {
    if (!dealerId) throw new Error("Dealer ID is required for deletion");
    try {
      const response = await apiService.delete<APIResponseType>(`${this.ENDPOINT}/${dealerId}`);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async editDealer(dealerId: string, payload: Partial<any>): Promise<APIResponseType> {
    if (!dealerId) throw new Error("Dealer ID is required for editing");
    if (!Object.keys(payload).length) throw new Error("Edit payload cannot be empty");

    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${dealerId}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default Dealer;
